import { render, staticRenderFns } from "./485Tem.vue?vue&type=template&id=8cc4fbec&scoped=true"
import script from "./485Tem.vue?vue&type=script&lang=js"
export * from "./485Tem.vue?vue&type=script&lang=js"
import style0 from "./485Tem.vue?vue&type=style&index=0&id=8cc4fbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc4fbec",
  null
  
)

export default component.exports